import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withRouter } from "../../../utils/router";
import { apiUrl } from "../../../utils/apiUrl";
import { formatDate, getLink, toast } from "../../../utils/helpers";
import { postRequest, withRequest } from "../../../utils/request";
import Loader from "../../general/Loader";
import Modal from "../../general/Modal";
import Form from "./Form";
import SearchCedula from "./SearchCedula";

class Create extends Component {
    state = {
        errors: {},
        tutor: {},
        showSearch: false,
        search: "",
        searchResults: null,
        searchSuccess: null,
        searching: false,
    };
    createTutor = async (event) => {
        event.preventDefault();

        const data = new FormData(event.target);

        const response = await postRequest(apiUrl("academico/padres-tutores"), data);

        if (response.success) {
            this.props.history.push(getLink("/academico/padres-tutores"));
            toast('Tutor creado exitosamente.');
        }
        if (response.code === 422) {
            this.setState({ errors: response.data.message });
            toast('Favor revisar todos los campos.', 'error');
        }
    };
    toggleSearchModal = () => {
        this.setState({
            showSearch: !this.state.showSearch,
        });
    };
    buscarTutor = async (e) => {
        e.preventDefault();

        this.setState({
            searching: true,
        });

        const { search } = this.state;
        const url = `https://app.migente.com.do/api/getpadronexterno/?cedula=${search}&user=felipe_api&pswd=F3l1pe`;
        const response = await fetch(url);
        response.json().then((res) => {
            this.setState({
                searchResults: res.Persona,
                searchSuccess: res.Existe,
                searching: false,
            });
        });
    };
    insertarTutor = () => {
        const search = this.state.searchResults;

        if (!search) {
            return;
        }

        this.setState(prevState => {
            return {tutor: {
                ...prevState.tutor,
                nombre: search.Nombres,
                apellido:
                    search.Apellido1 +
                    " " +
                    (search.Apellido2 ? search.Apellido2 : ""),
                cedula: search.Cedula,
                fechaNacimiento: formatDate(Date.parse(search.FechaNacimiento)),
                direccion: search.Municipio + ", " + search.Provincia,
                foto: search.Imagen,
                fotoCed: search.Imagen,
                nacionalidad: "Dominicano",
            }}
        });
        this.toggleSearchModal();
    };
    onInputChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        });
    };
    render() {
        const {
            errors,
            tutor,
            searchResults,
            searching,
            searchSuccess,
        } = this.state;
        return (
            <div>
                <div className='page-header'>
                    <h1 className='page-title'>
                        Añadir Padre/Tutor
                    </h1>
                </div>
                <div className='col-md-8 offset-2'>
                    <form
                        method='post'
                        onSubmit={this.createTutor}
                        encType='multipart/form-data'>
                        <Form
                            tutor={tutor}
                            errors={errors}
                            toggleSearchModal={this.toggleSearchModal}
                        />
                        <div className='page-footer text-right'>
                            <Link
                                to={getLink("/academico/padres-tutores")}
                                className='btn btn-plain'>
                                Cancelar
                            </Link>
                            <button type='submit' className='btn btn-primary'>
                                Crear
                            </button>
                        </div>
                    </form>
                </div>
                <Modal
                    show={this.state.showSearch}
                    blank={true}
                    toggle={this.toggleSearchModal}>
                    <SearchCedula
                        searching={searching}
                        searchResults={searchResults}
                        searchSuccess={searchSuccess}
                        onInputChange={this.onInputChange}
                        buscarTutor={this.buscarTutor}
                        insertarTutor={this.insertarTutor}
                        toggleSearchModal={this.toggleSearchModal}
                    />
                </Modal>
            </div>
        );
    }
}

export default withRouter(withRequest(Create));
